/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRoadOff = createReactComponent("road-off", "IconRoadOff", [
  ["path", { d: "M4 19l3.332 -11.661", key: "svg-0" }],
  ["path", { d: "M16 5l2.806 9.823", key: "svg-1" }],
  ["path", { d: "M12 8v-2", key: "svg-2" }],
  ["path", { d: "M12 13v-1", key: "svg-3" }],
  ["path", { d: "M12 18v-2", key: "svg-4" }],
  ["path", { d: "M3 3l18 18", key: "svg-5" }]
]);

export { IconRoadOff as default };
//# sourceMappingURL=IconRoadOff.js.map
